import { render } from "./DhMapPolygon.vue?vue&type=template&id=2ed797d6"
import script from "./DhMapPolygon.vue?vue&type=script&lang=ts"
export * from "./DhMapPolygon.vue?vue&type=script&lang=ts"
script.render = render

export default script